import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import 'ol/ol.css';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import SourceImagestatic from 'ol/source/ImageStatic';
import LayerImage from 'ol/layer/Image';
import XYZ from 'ol/source/XYZ';
import { defaults } from 'ol/control';
import Attribution from 'ol/control/Attribution';
import { transformExtent, fromLonLat, transform } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import StyleIcon from 'ol/style/Icon';
import StyleText from 'ol/style/Text';
import StyleFill from 'ol/style/Fill';
import styleStroke from 'ol/style/Stroke';
import Feature from 'ol/Feature';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  name: 'jasMap',
  meta: {
    title: '地图'
  },
  data() {
    return {
      fid: this.$route.query.fid,
      formUserId: this.$route.query.formUserId,
      // this.$route.query.cfId
      mapconfigform: {
        formId: '177623',
        pageSize: 1
      },
      // this.$route.query.cdId
      mapdataform: {
        formId: '165054',
        limit: 100,
        searchStr: ''
      },
      mapconfigData: {
        mapbg: '',
        logo: '',
        type: '',
        staticImg: ''
      },
      mapcfData: '',
      map: null,
      mapconfig: {
        mapMinZoom: 10,
        mapMaxZoom: 13,
        center: [],
        extent: [],
        currentZoom: 10
      },
      mapcontainer: '',
      iconLayer: '',
      iconSource: '',
      imageLayer: '',
      wmsLayer: '',
      detail: '',
      // 定点详情对象
      swiperEl: '',
      // 弹窗轮播图ref
      typeList: [],
      // 分类列表
      currentType: 0,
      // 分类默认当前索引
      modeltype: 1,
      // 弹窗默认模板样式
      dotimgW: 100,
      // 定点图片默认宽度
      popshowflag: false,
      // 控制弹窗显隐
      linkcontainerflag: false,
      // 控制外链iframe显隐
      iframeurl: '',
      // iframe路径
      mapconfigdatas: {},
      // 地图管理配置对象
      listyleobj: {},
      // 分类默认样式对象
      listobjon: {},
      // 分类选中样式对象
      // 分类搜索字段
      typesearchStr: {
        'model': 0,
        'filters': [[{
          'id': 1,
          'alias': '3',
          'compt': 'editinput',
          'express': '===',
          'val': '',
          'range': null
        }]]
      },
      // 搜索定位点字段
      searchStr: {
        'model': 0,
        'filters': [[{
          'id': 1,
          'alias': 'map_level',
          'compt': 'editinput',
          'express': '<=',
          'val': '',
          'range': null
        }], [{
          'id': 3,
          'alias': '40',
          'compt': 'editinput',
          'express': '===',
          'val': '',
          'range': null
        }]]
      },
      mapTitle: '',
      zoom: 0,
      pointPage: 1,
      nationwide: require('../../../assets/map/ja/icon1.png'),
      provincialwide: require('../../../assets/map/ja/icon4.png'),
      cfeature: '',
      hoverId: ''
    };
  },
  mounted() {
    this.getmapconfigform();
    this.$nextTick(() => {
      this.swiperEl = new Swiper(this.$refs.swipercontainer, {
        initialSlide: 0,
        pagination: {
          el: this.$refs.swiperpage
        },
        autoplay: true,
        observeSlideChildren: true,
        observeParents: true,
        observer: true
      });
    });
    document.documentElement.style.setProperty('--hand-drawn-pop-colortheme1', `rgba(220, 191, 125, 1)`);
  },
  watch: {
    'mapconfigdatas.mapmodetype'(val) {
      if (val) {
        // console.log(val)
        // 获取切片地图
        if (val === '切片地图') this.Tilemap();
        if (val === '静态地图') this.staticmap();
      }
    },
    'mapconfig.currentZoom'(val) {
      // 获取地图配置项后 取当前层级渲染
      this.searchStr.filters.forEach(item => {
        if (item[0].alias === 'map_level') item[0].val = val;
        if (item[0].alias === '40') item[0].val = this.mapconfigdatas['46'];
      });
      this.mapdataform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.getmapdataform();
    },
    '$route'(to, from) {
      if (!this._isMobile()) return;
      location.reload();
    }
  },
  methods: {
    // 获取表单字段结构 属性
    getformstruct() {
      let params = {
        formId: '260297',
        pageSize: 1,
        deptId: this.fid
      };
      this.typesearchStr.filters.forEach(item => {
        if (item[0].alias === '3') item[0].val = this.mapconfigdatas['46'];
      });
      params.searchStr = encodeURI(JSON.stringify(this.typesearchStr));
      this.$api.singleadvanceSearch(params).then(res => {
        if (res.dataList.length > 0) {
          res.dataList.reverse().forEach((item, index) => {
            let title = item.formIdValueData[1].groupValues[0].values[0][0].val;
            this.typeList.push({
              title: title
            });
            this.typeList[index].pointList = [];
            this.getAllPoints(index, title, 1);
          });
        }
      });
    },
    // 获取所有的点
    getAllPoints(index, title, page) {
      let _this = this;
      let params = this.mapdataform;
      params.deptId = this.fid;
      params.limit = 99;
      params.page = page;
      let searchStr = {
        'model': 0,
        'filters': [[{
          'id': 40,
          'alias': '40',
          'compt': 'selectbox',
          'express': '!==',
          'val': [this.mapTitle],
          'range': null
        }], [{
          'id': 31,
          'alias': 'map_type',
          'compt': 'selectbox',
          'express': '===',
          'val': [title],
          'range': null
        }]]
      };
      params.searchStr = encodeURI(JSON.stringify(searchStr));
      let list = [];
      this.$api.singleadvanceSearch(params).then(res => {
        list = res.dataList.map(item => {
          return {
            name: item.formIdValueData['place_name'].groupValues[0].values[0][0].val,
            mapCoordinates: item.formIdValueData['map_coordinates'].groupValues[0].values[0][0].val.split(','),
            id: item.id,
            image: _this.handleHttp(item.formIdValueData[4].groupValues[0].values[0][0].fileUrl)
          };
        });
        this.typeList[index].pointList = this.typeList[index].pointList.concat(list);
        if (res.totalPage != page) {
          this.getAllPoints(index, title, page + 1);
        }
      });
    },
    // 字符串驼峰式正则
    transformStr3(str) {
      let re = /_(\w)/g;
      return str.replace(re, ($0, $1) => {
        return $1.toUpperCase();
      });
    },
    // 表单无数据返回空
    getformdata(data) {
      let typekey = 'val';
      if (!data.groupValues) return '';
      if (!data.groupValues[0]) return '';
      let groupvalue = data.groupValues[0];
      if (data.compt === 'imagebox') typekey = 'fileUrl';
      return groupvalue.values.length && groupvalue.values[0] ? groupvalue.values[0][0] ? groupvalue.values[0][0][typekey] : '' : '';
    },
    getformitemsdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (data.compt === 'imagebox') typekey = 'fileUrl';
      return data.values.length && data.values[0] ? data.values[0][typekey] : '';
    },
    // 获取地图配置数据 方便多个地图配置
    getmapconfigform() {
      let _this = this;
      this.mapconfigform.deptId = this.fid;
      this.$api.singleformUserId(this.fid, this.mapconfigform.formId, this.formUserId).then(res => {
        _this.mapcfData = res.formUserList[0].formData;
        if (res.formUserList.length > 0) {
          _this.mapcfData.forEach(item => {
            _this.mapconfigdatas[_this.transformStr3(item.alias)] = _this.getformitemsdata(item);
          });
          _this.getformstruct();
          _this.mapTitle = _this.mapconfigdatas[46];
          document.title = _this.mapconfigdatas.toptitle = '' ? '地图' : _this.mapconfigdatas.toptitle;
          _this.mapconfig.extent = _this.mapconfigdatas.transformExtent.split(',');
          _this.mapconfig.extent.forEach((item, index) => {
            _this.mapconfig.extent[index] = Number(_this.mapconfig.extent[index]);
          });
          let modeltypeval = _this.mapconfigdatas.modeltype;
          _this.modeltype = modeltypeval.charAt(modeltypeval.length - 1);
          if (_this.mapconfigdatas.mapmodetype === '切片地图') {
            _this.mapconfig.mapMinZoom = Number(_this.mapconfigdatas.mapMinLevel);
            _this.mapconfig.mapMaxZoom = Number(_this.mapconfigdatas.mapMaxLevel);
          }
          if (_this.mapconfigdatas.mapmodetype === '静态地图') {
            _this.mapconfig.mapMinZoom = Number(_this.mapconfigdatas.staticMapMinLevel);
            _this.mapconfig.mapMaxZoom = Number(_this.mapconfigdatas.staticMapMaxLevel);
            _this.mapconfigData.staticImg = _this.mapconfigdatas.staticImg;
          }
          if (document.body.clientWidth < 768) {
            _this.mapconfigData.mapbg = _this.mapconfigdatas.appBgImg;
            _this.dotimgW = _this.mapconfigdatas.appimgW;
            _this.mapconfig.currentZoom = Number(_this.mapconfigdatas.appCurrentLevel);
            _this.mapconfig.center = _this.mapconfigdatas.appMapCenter.split(',');
            _this.mapconfig.center.forEach((item, index) => {
              _this.mapconfig.center[index] = Number(_this.mapconfig.center[index]);
            });
          } else {
            _this.mapconfigData.mapbg = _this.mapconfigdatas.backgroundImg;
            _this.dotimgW = _this.mapconfigdatas.dotimgW;
            _this.mapconfig.currentZoom = Number(_this.mapconfigdatas.currentLevel);
            _this.mapconfig.center = _this.mapconfigdatas.mapCenter.split(',');
            _this.mapconfig.center.forEach((item, index) => {
              _this.mapconfig.center[index] = Number(_this.mapconfig.center[index]);
            });
          }
          _this.listyleobj.width = _this.mapconfigdatas.typewidth + 'px';
          _this.listyleobj.height = _this.mapconfigdatas.typeheight + 'px';
          _this.listyleobj.lineHeight = _this.mapconfigdatas.typeheight + 'px';
          _this.listyleobj.color = _this.mapconfigdatas.typecolor;
          if (_this.mapconfigdatas.typebg !== '') _this.listyleobj.background = 'url(' + _this.mapconfigdatas.typebg + ') center center 100% no-repeat';
          _this.listobjon.width = _this.mapconfigdatas.typewidth + 'px';
          _this.listobjon.height = _this.mapconfigdatas.typeheight + 'px';
          _this.listobjon.lineHeight = _this.mapconfigdatas.typeheight + 'px';
          _this.listobjon.color = _this.mapconfigdatas.typefocuscolor + '!important';
          if (_this.mapconfigdatas.typefocusbg !== '') {
            _this.listobjon.background = 'url(' + _this.mapconfigdatas.typefocusbg + ') no-repeat!important';
            _this.listobjon.backgroundSize = '100% 100%!important';
            _this.listobjon.backgroundPosition = 'center!important';
          }
          // console.log(_this.listobjon)
        }
      });
    },
    // 获取地图点数据
    getmapdataform() {
      let _this = this;
      this.mapdataform.deptId = this.fid;
      this.$api.singleadvanceSearch(this.mapdataform).then(res => {
        if (res.dataList.length > 0) {
          res.dataList.forEach(item => {
            let itemdata = item;
            if (item.formIdValueData['34'].groupValues[0].values[0][0].val === '隐藏') return false;
            let mapCoordinates = item.formIdValueData['child_coordinates'].groupValues[0].values[0][0].val ? item.formIdValueData['child_coordinates'] : item.formIdValueData['map_coordinates'];
            mapCoordinates = mapCoordinates.groupValues[0].values[0][0].val.split(',');
            let mapCoordinatesX = Number(mapCoordinates[0]);
            let mapCoordinatesY = Number(mapCoordinates[1]);
            let iconFeature = new Feature({
              geometry: new Point(fromLonLat([mapCoordinatesX, mapCoordinatesY])),
              id: itemdata.id,
              name: item.formIdValueData['place_name'].groupValues[0].values[0][0].val,
              xy: [mapCoordinatesX, mapCoordinatesY]
            });
            let textstyle = '';
            if (this.mapconfigdatas['locationTitle'] === '显示') {
              textstyle = new StyleText({
                text: item.formIdValueData['place_name'].groupValues[0].values[0][0].val,
                font: 'bold 16px FZSHJW',
                fill: new StyleFill({
                  // 可以在此处设置字体样式，与css同
                  color: '#ffffff'
                }),
                // stroke: new styleStroke({    //文字边界宽度与颜色
                //   color: '#fff',
                //   width: 2
                // }),
                offsetX: 0,
                offsetY: 35
              });
            }
            let imgSrc = _this.handleHttp(item.formIdValueData[4].groupValues[0].values[0][0].fileUrl);
            imgSrc = item.formIdValueData['43'].groupValues[0].values[0][0].val === '00027' ? require('../../../assets/map/ja/icon4.png') : require('../../../assets/map/ja/icon1.png');
            let iconimage = new StyleIcon({
              src: imgSrc,
              offset: [0, 0],
              width: 100
            });
            if (this.$route.query.formUserId === '497632878') {
              iconimage = '';
              textstyle = new StyleText({
                text: item.formIdValueData['place_name'].groupValues[0].values[0][0].val,
                font: 'normal 16px 微软雅黑',
                fill: new StyleFill({
                  // 可以在此处设置字体样式，与css同
                  color: '#ffffff'
                }),
                offsetX: 0,
                offsetY: 0
              });
            }
            iconFeature.setStyle(new Style({
              image: iconimage,
              text: textstyle
            }));
            let iconstyle = iconFeature.getStyle();
            // console.log(iconstyle.image_.iconImage_.src_)
            // 处理图片宽度自适应地图
            if (iconimage !== '') {
              let img = new Image();
              img.src = iconstyle.image_.iconImage_.src_;
              img.onload = function () {
                let width = img.width;
                // 以宽度为100为例
                let imgmultiple = _this.dotimgW / width;
                iconstyle.getImage().setScale(imgmultiple);
                iconFeature.setStyle(iconstyle);
                _this.iconSource.addFeature(iconFeature);
              };
            } else {
              _this.iconSource.addFeature(iconFeature);
            }
          });
        }
      });
    },
    // 获取切片地图
    Tilemap() {
      this.mapcontainer = this.$refs.maps;
      const mapExtent = transformExtent(this.mapconfig.extent, 'EPSG:4326', 'EPSG:3857');
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource
      });
      this.wmsLayer = new TileLayer({
        extent: mapExtent,
        source: new XYZ({
          attributions: [new Attribution({
            html: '1; Rendered with <a href="https://www.maptiler.com/">MapTiler Desktop</a>'
          })],
          url: 'tiles/' + this.fid + '/{z}/{x}/{y}.png',
          tilePixelRatio: 1.000000,
          minZoom: this.mapconfig.mapMinZoom,
          maxZoom: this.mapconfig.mapMaxZoom
        })
      });
      this.map = new Map({
        controls: defaults({
          attribution: false
        }),
        target: this.mapcontainer,
        layers: [this.wmsLayer, this.iconLayer],
        logo: false,
        view: new View({
          // extent: [100, 10, 128, 56],
          center: fromLonLat(this.mapconfig.center),
          zoom: this.mapconfig.currentZoom,
          minZoom: this.mapconfig.mapMinZoom,
          maxZoom: this.mapconfig.mapMaxZoom
        })
      });
      this.map.on('singleclick', this.singleclick);
      this.map.on('click', this.markerclick);
    },
    // 静态地图
    staticmap() {
      this.mapcontainer = this.$refs.maps;
      let extent = this.mapconfig.extent;
      let projection = new Projection({
        code: 'xkcd-image',
        units: 'pixels',
        extent: extent
      });
      // console.log(this.mapconfigData.staticImg)
      // console.log(this.mapconfig.center)
      this.imageLayer = new LayerImage({
        source: new SourceImagestatic({
          url: this.handleHttp(this.mapconfigData.staticImg),
          //这里添加静态图片的地址
          projection: projection,
          imageExtent: extent
        })
      });
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource
      });
      this.map = new Map({
        controls: defaults({
          attribution: false
        }),
        layers: [this.imageLayer, this.iconLayer],
        target: this.mapcontainer,
        view: new View({
          projection: projection,
          center: this.mapconfig.center,
          zoom: this.mapconfig.currentZoom,
          minZoom: this.mapconfig.mapMinZoom,
          maxZoom: this.mapconfig.mapMaxZoom
        })
      });
      this.map.on('singleclick', this.singleclick);
      this.map.on('click', this.markerclick);
      let _this = this;
      this.map.on('moveend', function (event) {
        _this.resolutionchange(event);
      });
      this.map.on('pointermove', this.markermove);
    },
    // 移动显示标题
    markermove(evt) {
      if (this.$route.query.formUserId === '497632878') return;
      let allfeatures = this.iconSource.getFeatures();
      allfeatures.forEach(item => {
        if (item.get('hover')) {
          this.iconSource.removeFeature(item);
        }
      });
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      if (feature) {
        let featureName = feature.get('name');
        let featureCenter = feature.get('xy');
        let featureId = feature.get('id');
        this.hoverId = featureId;
        let iconFeature = new Feature({
          geometry: new Point(fromLonLat(featureCenter)),
          id: `0${featureId}`,
          name: featureName,
          hover: true
        });
        iconFeature.setStyle(new Style({
          text: new StyleText({
            text: featureName,
            font: 'bold 16px FZSHJW',
            fill: new StyleFill({
              // 可以在此处设置字体样式，与css同
              color: '#F8EDB9'
            }),
            stroke: new styleStroke({
              //文字边界宽度与颜色
              color: '#8B0D13',
              width: 2
            }),
            offsetX: 0,
            offsetY: 38
          })
        }));
        this.iconSource.addFeature(iconFeature);
      }
    },
    // 获取当前 地图位置
    singleclick(val) {
      let coordinateArr = transform(val.coordinate, 'EPSG:3857', 'EPSG:4326');
      console.log("coordinate: " + coordinateArr[0].toFixed(6) + "," + coordinateArr[1].toFixed(6));
    },
    // 处理表单数据
    getformitemdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (data.compt === 'imagebox') return data.values.length ? data.values : '';
      if (data.compt === 'location') return data.values.length ? data.values : '';
      if (data.compt === 'videobox' || data.compt === 'fileupload') typekey = 'objectId';
      return data.values.length && data.values[0] ? data.values[0][typekey] : '';
    },
    // 处理请求协议
    handleHttp(val) {
      return val;
      // let currenthttp = location.protocol
      // let fileUrl = 'https://museum.chaoxing.com/star3/origin/'
      // if (val !== undefined) {
      //   if (currenthttp === 'https:') {
      //     return val.replace('http:', currenthttp)
      //   } else {
      //     return val.replace('https://pan-yz.chaoxing.com/thumbnail/origin/', fileUrl)
      //   }
      // }
    },
    // 点击当前 定位点
    markerclick(evt) {
      // console.log(evt)
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      if (feature) {
        let featureId = feature.get('id');
        let _this = this;
        // console.log('featureId', featureId)
        this.$api.singleformUserId(this.fid, this.mapdataform.formId, featureId).then(res => {
          let detaildata = res.formUserList[0].formData;
          // console.log(detaildata)
          let deatilObj = {
            currentShowtype: 'banner'
          };
          detaildata.forEach(item => {
            deatilObj[_this.transformStr3(item.alias)] = _this.getformitemdata(item);
          });
          this.detail = deatilObj;
          let url = deatilObj['44'];
          url !== '' ? this._isMobile() ? window.location.href = url : window.open(url) : this.popshowflag = true;
          // console.log(deatilObj)
        });
      }
    },
    showType(val) {
      this.detail.currentShowtype = val;
      if (val !== 'banner') {
        this.$api.getUrlByObjectId(this.detail[val]).then(res => {
          let currenthttp = location.protocol;
          if (currenthttp === 'https:') {
            this.detail[val + 'url'] = res.download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/');
          } else {
            this.detail[val + 'url'] = res.download;
          }
        });
      }
    },
    closepopshow() {
      this.detail = '';
      this.popshowflag = false;
    },
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = '';
    },
    // 跳转
    goLink(url, type) {
      this.linkcontainerflag = true;
      if (type === 1) {
        this.iframeurl = url;
      }
      if (type === 0) {
        // console.log(url)
        if (url !== undefined) {
          let locationurl = url.route[0].lng + ',' + url.route[0].lat;
          if (document.body.clientWidth < 768) {
            this.iframeurl = 'https://m.amap.com/share/index/lnglat=' + locationurl + '&name=' + this.detail.name + '&src=uriapi&innersrc=uriapi';
          } else {
            this.iframeurl = 'https://ditu.amap.com/regeo?lng=' + url.route[0].lng + '&lat=' + url.route[0].lat + '&zoom=12';
          }
        }
      }
    },
    // 地图实时放大缩小事件
    resolutionchange(event) {
      let zoom = Math.round(event.map.getView().getZoom());
      if (this.zoom === zoom) return;
      this.zoom = zoom;
      this.mapdataform.page = 1;
      this.searchStr.filters.forEach(item => {
        if (item[0].alias === 'map_level') {
          item[0].val = zoom;
        }
      });
      this.mapdataform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.iconSource.clear();
      this.getmapdataform();
    },
    isInteger(obj) {
      return typeof obj === 'number' && obj % 1 === 0;
    },
    // 筛选类型
    typeselect(val, index) {
      console.log(val);
      if (this.cfeature !== '') {
        this.iconSource.removeFeature(this.cfeature);
      }
      this.detail = '';
      let _this = this;
      // this.iconSource.clear()
      let mapCoordinatesX = Number(val.mapCoordinates[0]);
      let mapCoordinatesY = Number(val.mapCoordinates[1]);
      let iconFeature = new Feature({
        geometry: new Point(fromLonLat([mapCoordinatesX, mapCoordinatesY])),
        id: val.id,
        name: val.name
      });
      let textstyle = '';
      // if (this.mapconfigdatas['locationTitle'] === '显示') {
      textstyle = new StyleText({
        text: val.name,
        font: 'bold 16px FZSHJW',
        fill: new StyleFill({
          // 可以在此处设置字体样式，与css同
          color: '#F8EDB9'
        }),
        stroke: new styleStroke({
          //文字边界宽度与颜色
          color: '#8B0D13',
          width: 2
        }),
        offsetX: 0,
        offsetY: 38
      });
      // }
      iconFeature.setStyle(new Style({
        image: new StyleIcon({
          src: index === 0 ? _this.nationwide : _this.provincialwide,
          offset: [0, 0],
          width: 100
        }),
        text: textstyle
      }));
      let iconstyle = iconFeature.getStyle();
      // 处理图片宽度自适应地图
      let img = new Image();
      img.src = iconstyle.image_.iconImage_.src_;
      img.onload = function () {
        let width = img.width;
        // 以宽度为100为例
        let imgmultiple = 44 / width;
        iconstyle.getImage().setScale(imgmultiple);
        iconFeature.setStyle(iconstyle);
        // console.log(_this)
        _this.iconSource.addFeature(iconFeature);
        _this.cfeature = iconFeature;
      };
      // this.getmapdataform()
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    }
  }
};